import {
  ref,
  computed,
  useRoute,
  useContext,
  onBeforeMount,
  ssrRef,
} from '@nuxtjs/composition-api';

const DISABLED_TYPES_OF_DOCUMENTS = ['Certificates', 'Privacy Policy'];
const VIDEO_TYPE = 'Video guide';

const useFetchProduct = () => {
  const {
    error: showErrorPage,
    ssrContext,
    nuxtState,
    $api: { productsService, documentsService },
  } = useContext();
  const isLoadingProduct = ref();
  const product = ref(null);
  const isLoadingDocuments = ref(false);
  const allDocuments = ref(null);
  const productDocuments = ref([]);
  const productUserGuides = ref([]);
  const route = useRoute();
  const slug = computed(() => route.value.params.slug);
  const error = ssrRef('false', 'error');

  const filterDocuments = () => {
    Object.entries(allDocuments.value).forEach((entry) => {
      const [key, value] = entry;
      if (key === VIDEO_TYPE) {
        productUserGuides.value.push(...value);
        return;
      }

      if (!DISABLED_TYPES_OF_DOCUMENTS.includes(key)) {
        productDocuments.value.push(...value);
      }
    });
  };

  const fetchProduct = async () => {
    isLoadingProduct.value = true;
    try {
      const { data } = await productsService.getProductBySlug(slug.value);
      product.value = data;
    } catch (_) {
      if (process.server) {
        ssrContext.res.statusCode = 404;
        error.value = 'true';
      } else showErrorPage({ statusCode: 404 });
    } finally {
      isLoadingProduct.value = false;
    }
  };

  const fetchProductDocuments = async () => {
    isLoadingDocuments.value = true;
    try {
      const { data } = await documentsService.getAllDocuments({
        product_sku: product.value.sku,
      });

      allDocuments.value = data;
    } finally {
      isLoadingDocuments.value = false;
    }
  };

  onBeforeMount(() => {
    if (error.value === 'true') {
      showErrorPage({ statusCode: 404 });
      nuxtState.ssrRefs.error = 'false';
    }
  });

  return {
    isLoadingProduct,
    product,
    isLoadingDocuments,
    allDocuments,
    productDocuments,
    productUserGuides,
    fetchProduct,
    fetchProductDocuments,
    filterDocuments,
  };
};

export default useFetchProduct;
